/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Cancel_Estes_Pickup_Description_ManyInputs */

const en_orders_cancel_estes_pickup_description_many = /** @type {(inputs: Orders_Cancel_Estes_Pickup_Description_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cancel pickup for ${i?.count} selected ESTES orders?`)
};

const es_orders_cancel_estes_pickup_description_many = /** @type {(inputs: Orders_Cancel_Estes_Pickup_Description_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cancelar recoleccion de ${i?.count} pedidos ESTES seleccionados?`)
};

/**
* | output |
* | --- |
* | "Cancel pickup for {count} selected ESTES orders?" |
*
* @param {Orders_Cancel_Estes_Pickup_Description_ManyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_estes_pickup_description_many = /** @type {((inputs: Orders_Cancel_Estes_Pickup_Description_ManyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_Estes_Pickup_Description_ManyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_estes_pickup_description_many(inputs)
	return es_orders_cancel_estes_pickup_description_many(inputs)
});